/**
 * Sitewide on/off toggle. Controlled: `checked` + `onChange(nextChecked)`.
 * Renders a real checkbox (visually hidden) under a styled track/thumb so
 * keyboard nav, focus rings, and form semantics all work for free.
 */
export default function Switch({ checked, onChange, disabled, label, id }) {
	const inputId = id || (label ? `switch-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);

	const switchEl = (
		<span className={`relative inline-flex shrink-0 ${disabled ? '' : 'cursor-pointer'}`}>
			<input
				id={inputId}
				type='checkbox'
				role='switch'
				className='peer sr-only'
				checked={Boolean(checked)}
				disabled={disabled}
				onChange={(e) => onChange?.(e.target.checked)}
			/>
			<span
				className={`h-6 w-11 rounded-full transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-black ${
					checked ? 'bg-black' : 'bg-gray-300'
				} ${disabled ? 'opacity-50' : ''}`}
			/>
			<span
				className={`absolute left-0.5 top-0.5 size-5 rounded-full bg-white shadow transition-transform pointer-events-none ${
					checked ? 'translate-x-5' : 'translate-x-0'
				}`}
			/>
		</span>
	);

	if (!label) return <label htmlFor={inputId}>{switchEl}</label>;

	return (
		<label htmlFor={inputId} className={`flex items-center gap-2 text-sm ${disabled ? '' : 'cursor-pointer'}`}>
			{switchEl}
			<span className='text-gray-700 normal-case'>{label}</span>
		</label>
	);
}
